import { PrincipalType } from '../model';

export const PRINCIPAL_TYPE_LABEL_MAP: Record<PrincipalType, string> = {
  [PrincipalType.Tenant]: 'Тенант',
  [PrincipalType.Client]: 'Клієнт',
  [PrincipalType.Machine]: 'Машина',
};
